import { useThemeContext } from '../context/theme-context';
import { BsSun, BsMoon } from 'react-icons/bs';
import './toggle-switch.css';

const ToggleSwitch = () => {
  const { themeState, themeHandler } = useThemeContext();
  const isDark = themeState.theme === 'dark-theme';

  const toggleTheme = () => {
    themeHandler(isDark ? 'light-theme' : 'dark-theme');
  };

  return (
    <div className="toggle-switch">
      <BsSun className="sun-icon" />
      <label className="switch">
        <input
          type="checkbox"
          checked={isDark}
          onChange={toggleTheme}
        />
        <span className="slider"></span>
      </label>
      <BsMoon className="moon-icon" />
    </div>
  );
};

export default ToggleSwitch; 